export default "__VITE_ASSET__B_0T6YIz__"